module.exports = __webpack_public_path__ + "img/Weapon_102.c6cf70b0.png";